export const PRISM_SCORE = {
  masterTableName: "MC_PRISM_SCORE",
  tableName: "MC_PRISM_SCORE_DET",
  columnName: "PS_ID",
  columnValue: 0,
  title: "prism-score.title",
  rows: [
    { title: "id", value: "ID" },
    { title: "date", value: "PROCESS_TIME", headerName: "datetime", type: "date" },
    { title: "systolic_blood_pressure", value: "SYSTOLIC_BLOOD_PRESSURE_XNAME" },
    { title: "diastolic_blood_pressure", value: "DIASTOLIC_BLOOD_PRESSUR_XNAME" },
    { title: "heart_rate", value: "HEART_RATE_XNAME" },
    { title: "respiratory_rate", value: "RESPIRATORY_RATE_XNAME" },
    { title: "pao2_flo2", value: "PAO2_FLO2_XNAME" },
    { title: "paco2", value: "PACO2_XNAME" },
    { title: "pt_ptt", value: "PT_PTT_XNAME" },
    { title: "total_bilirubin", value: "TOTAL_BILIRUBIN_XNAME" },
    { title: "calcium", value: "CALCIUM_XNAME" },
    { title: "potassium", value: "POTASSIUM_XNAME" },
    { title: "glucose", value: "GLUCOSE_XNAME" },
    { title: "hco3", value: "HCO3_XNAME" },
    { title: "pupil_reaction", value: "PUPIL_REACTION_XNAME" },
    { title: "glasgow_score", value: "GLASGOW_SCORE" },
    { title: "prism_score", value: "PRISM_SCORE" },
    { title: "expected_death_rate", value: "EXPECTED_DEATH_RATE" },
    { title: "postoperative_expected_death", value: "POSTOPERATIVE_EXPECTED_DEATH" },
    { title: "note", value: "NURSE_NOTE" },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "systolic_blood_pressure", headerName: "prism-score.systolic-blood-pressure", flex: 1 },
    { field: "diastolic_blood_pressure", headerName: "prism-score.diastolic-blood-pressure", flex: 1 },
    { field: "heart_rate", headerName: "prism-score.heart-rate", flex: 1 },
    { field: "respiratory_rate", headerName: "prism-score.respiratory-rate", flex: 1 },
    { field: "pao2_flo2", headerName: "prism-score.paofio", flex: 1 },
    { field: "paco2", headerName: "prism-score.partial-carbon-dioxide-pressure", flex: 1 },
    { field: "pt_ptt", headerName: "prism-score.ptptt", flex: 1 },
    { field: "total_bilirubin", headerName: "prism-score.total-bilirubin", flex: 1 },
    { field: "calcium", headerName: "prism-score.calcium", flex: 1 },
    { field: "potassium", headerName: "prism-score.potassium", flex: 1 },
    { field: "glucose", headerName: "prism-score.glucose", flex: 1 },
    { field: "hco3", headerName: "prism-score.bicarbonate", flex: 1 },
    { field: "pupil_reaction", headerName: "prism-score.pupil-reaction", flex: 1 },
    { field: "glasgow_score", headerName: "prism-score.glasgow-score", flex: 1 },
    {
      field: "prism_score",
      headerName: "score",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        const systolic = Number(row.SYSTOLIC_BLOOD_PRESSURE_XVALUE) || 0;
        const diastolic = Number(row.DIASTOLIC_BLOOD_PRESSURE_XVALUE || row.DIASTOLIC_BLOOD_PRESSUR_XVALUE) || 0;
        const heartRate = Number(row.HEART_RATE_XVALUE) || 0;
        const respRate = Number(row.RESPIRATORY_RATE_XVALUE) || 0;
        const pao2 = Number(row.PAO2_FLO2_XVALUE) || 0;
        const paco2 = Number(row.PACO2_XVALUE) || 0;
        const ptPtt = Number(row.PT_PTT_XVALUE) || 0;
        const bilirubin = Number(row.TOTAL_BILIRUBIN_XVALUE) || 0;
        const calcium = Number(row.CALCIUM_XVALUE) || 0;
        const potassium = Number(row.POTASSIUM_XVALUE) || 0;
        const glucose = Number(row.GLUCOSE_XVALUE) || 0;
        const hco3 = Number(row.HCO3_XVALUE) || 0;
        const pupil = Number(row.PUPIL_REACTION_XVALUE) || 0;
        return systolic + diastolic + heartRate + respRate + pao2 + paco2 + ptPtt + bilirubin + calcium + potassium + glucose + hco3 + pupil;
      }
    },
    { field: "expected_death_rate", headerName: "prism-score.expected-mortality-rate", flex: 1 },
    { field: "postoperative_expected_death", headerName: "prism-score.postoperative-expected-mortality-rate", flex: 1 },
    { field: "note", headerName: "note", flex: 1 },
  ],
  mcpConfig: {
    SYSTOLIC_BLOOD_PRESSURE: { mcpId: 430, field: "SYSTOLIC_BLOOD_PRESSURE", scoreField: "SYSTOLIC_BLOOD_PRESSURE_XVALUE" },
    DIASTOLIC_BLOOD_PRESSURE: { mcpId: 431, field: "DIASTOLIC_BLOOD_PRESSURE", scoreField: "DIASTOLIC_BLOOD_PRESSURE_XVALUE" },
    HEART_RATE: { mcpId: 432, field: "HEART_RATE", scoreField: "HEART_RATE_XVALUE" },
    RESPIRATORY_RATE: { mcpId: 433, field: "RESPIRATORY_RATE", scoreField: "RESPIRATORY_RATE_XVALUE" },
    PAO2_FLO2: { mcpId: 434, field: "PAO2_FLO2", scoreField: "PAO2_FLO2_XVALUE" },
    PACO2: { mcpId: 435, field: "PACO2", scoreField: "PACO2_XVALUE" },
    PT_PTT: { mcpId: 436, field: "PT_PTT", scoreField: "PT_PTT_XVALUE" },
    TOTAL_BILIRUBIN: { mcpId: 437, field: "TOTAL_BILIRUBIN", scoreField: "TOTAL_BILIRUBIN_XVALUE" },
    CALCIUM: { mcpId: 438, field: "CALCIUM", scoreField: "CALCIUM_XVALUE" },
    POTASSIUM: { mcpId: 439, field: "POTASSIUM", scoreField: "POTASSIUM_XVALUE" },
    GLUCOSE: { mcpId: 440, field: "GLUCOSE", scoreField: "GLUCOSE_XVALUE" },
    HCO3: { mcpId: 441, field: "HCO3", scoreField: "HCO3_XVALUE" },
    PUPIL_REACTION: { mcpId: 442, field: "PUPIL_REACTION", scoreField: "PUPIL_REACTION_XVALUE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    PS_ID: "",
    PROCESS_TIME: new Date(),
    NURSE_ID: "",
    CTIME: new Date(),
    CUSER: "",
    SYSTOLIC_BLOOD_PRESSURE: "",
    DIASTOLIC_BLOOD_PRESSURE: "",
    HEART_RATE: "",
    RESPIRATORY_RATE: "",
    PAO2_FLO2: "",
    PACO2: "",
    PT_PTT: "",
    TOTAL_BILIRUBIN: "",
    CALCIUM: "",
    POTASSIUM: "",
    GLUCOSE: "",
    HCO3: "",
    PUPIL_REACTION: "",
    PRISM_SCORE: 0,
    GLASGOW_SCORE: "",
    LESS_THEN: "0",
    EXPECTED_DEATH_RATE: 0,
    POSTOPERATIVE_EXPECTED_DEATH: 0,
    HOW_MANY_MONTHS: 0,
    MICRDS_ID: "",
    NURSE_NOTE: "",
    GLASGOW_SCORE_VALUE: 0,
  },
  chartScoreField: "PRISM_SCORE",
  chartTimeField: "PROCESS_TIME",
};
